/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Description"
    }), "\n", _jsx(_components.p, {
      children: "The ToggleButton component should be used to toggle on or off a limited number of choices."
    }), "\n", _jsxs(_components.p, {
      children: ["You can use the React component ", _jsx(_components.code, {
        children: "<ToggleButton.Group>"
      }), " to wrap several ", _jsx(_components.code, {
        children: "ToggleButton"
      }), ". This makes it easier to handle the event ", _jsx(_components.code, {
        children: "on_change"
      }), " on a higher level - as well as several other ", _jsx(_components.a, {
        href: "/uilib/components/toggle-button/properties",
        children: "context related properties"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["By default the ", _jsx(_components.code, {
        children: "ToggleButton.Group"
      }), " is single-select, like a ", _jsx(_components.a, {
        href: "/uilib/components/radio",
        children: "Radio"
      }), " button. But you can easily enable ", _jsx(_components.code, {
        children: "multiselect"
      }), " as well."]
    }), "\n", _jsx(_components.h2, {
      children: "How to use"
    }), "\n", _jsxs(_components.p, {
      children: ["You can use the ToggleButton in different modes. Either as a stand-alone component or together with the ", _jsx(_components.code, {
        children: "ToggleButton.Group"
      }), " context."]
    }), "\n", _jsx(_components.h3, {
      children: "Multi select"
    }), "\n", _jsxs(_components.p, {
      children: ["If ", _jsx(_components.code, {
        children: "multiselect"
      }), " is enabled on the group, several items can be enabled/disabled by the user."]
    }), "\n", _jsxs(_components.p, {
      children: ["You would have to decide if you want to track the state by yourself by using the ", _jsx(_components.code, {
        children: "checked"
      }), " property, or you want just to listen to the internal state with ", _jsx(_components.code, {
        children: "on_change(({ values } => console.log(values)))"
      }), ". You have then to give every item also a ", _jsx(_components.code, {
        children: "value"
      }), " property."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
